import { Component, OnInit, OnDestroy, Optional, Inject } from '@angular/core';
import { WsService } from '@app/shared';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-card-payment',
  templateUrl: './card-payment.component.html',
  styleUrls: ['./card-payment.component.scss']
})
export class CardPaymentComponent implements OnInit, OnDestroy {
  componentDestroyed = new Subject<any>();
  showSpinner = true;
  message = 'WAIT_FOR_HOLD_APPROVE';
  order: any = {};
  amount;

  successRes = ['hold_approved', 'hold_declined', 'hold_expired', 'captured'];

  constructor(
    private ws: WsService,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any
  ) {}

  ngOnInit() {
    this.order = this.data.order;
    this.amount = this.data.amount;
    this.ws.message.pipe(takeUntil(this.componentDestroyed)).subscribe(msg => {
      const res = JSON.parse(msg);
      if (res.header.type == 'invoice' && res.data.request_id == this.order.id) {
        this.message = res.data.status;
        this.showSpinner = !(this.successRes.indexOf(this.message) + 1);
        if (res.data) {
          if (this.order.trip.invoices) {
            this.order.trip.invoices.push(res.data);
          } else {
            this.order.trip.invoices = [res.data];
          }
        }
      }
    });
  }

  ngOnDestroy() {
    this.componentDestroyed.next(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/card-payment/card-payment.component.ts